import React from 'react';
import { View, TouchableOpacity, Linking, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import QText from './QText';
import PhoneIcon from './Icons/PhoneIcon';

const UserContactInfo = ({
  name,
  mobileNumber,
  centerAlign = false,
  showIcon = true,
  customStyles = {},
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const styles = createStyles(theme);

  const handlePhonePress = () => {
    if (mobileNumber) {
      Linking.openURL(`tel:${mobileNumber}`);
    }
  };

  if (!name && !mobileNumber) return null;

  return (
    <View style={[styles.container, customStyles.container]}>
      {name && (
        <View style={[styles.infoRow, centerAlign && styles.centerRow]}>
          <QText style={[styles.label, centerAlign && styles.centerText]}>
            {t('name')}:
          </QText>
          <QText style={[styles.value, centerAlign && styles.centerText]}>
            {name}
          </QText>
        </View>
      )}

      {mobileNumber && (
        <TouchableOpacity onPress={handlePhonePress} activeOpacity={0.7}>
          <View style={[styles.infoRow, centerAlign && styles.centerRow]}>
            <QText style={[styles.label, centerAlign && styles.centerText]}>
              {t('mobile_number')}:
            </QText>
            <View style={styles.phoneContainer}>
              <QText
                style={[styles.phoneNumber, centerAlign && styles.centerText]}
              >
                {mobileNumber}
              </QText>
              {showIcon && (
                <PhoneIcon
                  width={18}
                  height={18}
                  color={theme.colors.primary}
                  style={styles.phoneIcon}
                />
              )}
            </View>
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
};

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      marginVertical: 8,
    },
    infoRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginVertical: 4,
      gap: 8,
    },
    centerRow: {
      justifyContent: 'center',
    },
    label: {
      fontSize: 16,
      color: theme.colors.whiteTxt,
    },
    value: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.colors.whiteTxt,
    },
    phoneContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
    },
    phoneNumber: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.colors.primary,
    },
    phoneIcon: {
      marginLeft: 4,
    },
    centerText: {
      textAlign: 'center',
    },
  });

export default UserContactInfo;
